<template>
    <div>
        <v-card elevation="0">
            <v-card-text>
                <v-card elevation="0" outlined style="border-color:#D4C88D;">
                    <v-card-text>
                        <v-form ref="form" lazy-validation>
                        <v-row dense no-gutters>
                            <v-col cols="3">
                                <v-select class="ma-2" dense outlined v-model="subject" :items="disciplineitems" label="Subject/Discipline" item-text="label" item-value="value" :loading="disciplineloading" :loader-height="3" @change="checkForChanges" :rules="[v=> v.length > 0 || 'Required Field']"></v-select>
                            </v-col>
                            <v-col cols="3">
                                <v-text-field class="ma-2" dense outlined v-model="course" @keydown="checkForChanges" :rules="[v=> exportanycoursespermission || (!exportanycoursespermission && (!(/any/i.test(v) || /.\*/.test(v)))) || 'Permission not set for `any`']">
                                    <template v-slot:label>
                                        <span v-if="exportanycoursespermission">Course: 'ANY' will export for any courses</span>
                                        <span v-else>Course</span>
                                    </template>
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field class="ma-2" dense outlined v-model="section" label="Section" :rules="[v=> (/^any$/.test(v) || /^[0-9]{3}$/.test(v)) || 'Section contains 3 numbers unless any']" @keydown="checkForChanges"></v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-radio-group v-model="section" dense hide-details @change="checkForChanges">
                                    <v-radio
                                        label="Any Section"
                                        value="any"
                                    ></v-radio>
                                </v-radio-group>
                            </v-col>
                            <v-col cols="2">
                                <v-select class="ma-2" dense outlined v-model="ssrcomponent" :items="ssrcomponentitems" label="SSR Comp." item-text="label" item-value="value" @change="checkForChanges" :rules="[v=> v.length > 0 || 'Required Field']"></v-select>
                            </v-col>
                            <v-col cols="6">
                                <v-menu
                                    v-model="menustart"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field class="ma-2" dense v-model="startdate" label="Date Range start" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" outlined :rules="[v=> !!v || 'Required Field']"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="startdate" no-title color="#D4C88D" @input="closeMenuStart"></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="6">
                                <v-menu
                                    v-model="menuend"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field class="ma-2" dense v-model="enddate" label="Date Range End" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" outlined :rules="[v=> !!v || 'Required Field']"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="enddate" :show-current="startdate" no-title color="#D4C88D" :allowed-dates="validateEndDate" @input="closeMenuEnd"></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="12">
                                <v-select class="ma-2" dense outlined v-model="exportmap" :items="exportmapitems" label="Export Map" @change="checkForChanges" hide-details item-text="label" item-value="value"></v-select>
                            </v-col>
                        </v-row>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="#D4C88D" class="white--text" @click="exportReport" :loading="exportloading">Export</v-btn>
                    </v-card-actions>
                </v-card><br />
                <v-card elevation="0" outlined style="border-color:#D4C88D;" v-if="exportsuccess">
                    <v-card-title>Export Preview</v-card-title>
                    <v-card-subtitle>The following is the preview of the current export. Download will start automatically.</v-card-subtitle>
                    <v-card-text>
                        <v-simple-table style="width: 70%; border-collapse: collapse;" dense>
                            <template v-slot:default>
                                <tbody>
                                    <tr>
                                        <th>Subject</th>
                                        <td>{{ subject }}</td>
                                    </tr>
                                    <tr>
                                        <th>Course</th>
                                        <td>{{ course }}</td>
                                    </tr>
                                    <tr>
                                        <th>Section</th>
                                        <td>{{ section }}</td>
                                    </tr>
                                    <tr>
                                        <th>Date Range</th>
                                        <td>{{ startdate }} ~ {{ enddate }}</td>
                                    </tr>
                                    <tr>
                                        <th>Export Map</th>
                                        <td>{{ exportmap }}</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                        <br />
                        <v-data-table
                            :headers="exportResultHeaders"
                            :items="exportResultData"
                            hide-default-footer
                            dense
                        ></v-data-table>
                    </v-card-text>
                </v-card>
            </v-card-text>
        </v-card>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarcolor"
            :timeout="timeout"
        >
            {{ text }}
        </v-snackbar>
    </div>
</template>
<script>
import auth from '@/js/auth';
export default {
    data(){
        return {
            exportallpermission: false,
            exportanycoursespermission: false,
            host: location.hostname.toString(),
            disciplineitems: [],
            disciplineloading: true,
            exportmapitems: ["CUPE part time faculty appointments"],
            ssrcomponent: "LEC",
            ssrcomponentitems: ["LEC", "LAB", "TUT"],
            menustart: false,
            menuend: false,
            subject: "",
            course: "",
            section: "",
            startdate: "",
            enddate: "",
            exportmap: "CUPE part time faculty appointments",
            exportloading: false,
            exportsuccess: false,
            exportResultHeaders: [],
            exportResultData: [],
            downloadloading: false,
            snackbar: false,
            snackbarcolor: "",
            text: "",
            timeout: 3500,
        }
    },
    methods: {
        getPermissions(){
            const that = this;
            let permission = auth.get_permissions();

            if(permission.hasOwnProperty("exposeAll")){
                if(permission.exposeAll == 1){
                    that.exportallpermission = true;
                }else {
                    that.exportallpermission = false;
                }
            }else if(permission.hasOwnProperty("rootgroup")){
                that.exportallpermission = true;
            }else {
                that.exportallpermission = false;
            }

            if(permission.hasOwnProperty("exportAllowAnyCourse")){
                if(permission.exportAllowAnyCourse == 1){
                    that.exportanycoursespermission = true;
                }else {
                    that.exportanycoursespermission = false;
                }
            }else if(permission.hasOwnProperty("rootgroup")){
                that.exportanycoursespermission = true;
            }else {
                that.exportanycoursespermission = false;
            }
        },
        getSubjectList(){
            const that = this;
            that.disciplineloading = true;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=exportFormItems';

            that.disciplineitems = [{"label": "Please select...", "value": ""}];

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return json response
                    return response.json();
                })
                .then(function (json) {
                    if (json.result.match(/^OK/i)) {
                        if(json.data.length > 0){
                            if(json.data[0].hasOwnProperty("filteredDisciplines")){
                                that.disciplineitems.push(...json.data[0]["filteredDisciplines"]);
                            }
                            
                            if(that.exportallpermission){
                                that.disciplineitems.push({"label": "All subjects", "value": "all"});
                            }

                            if(json.data[1].hasOwnProperty("exportMaps")){
                                that.exportmapitems = json.data[1]["exportMaps"];
                            }else {
                                that.exportmapitems = ["CUPE part time faculty appointments"];
                            }
                        }
                    }

                    that.disciplineloading = false;
                })
                .catch(function (err) {
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                    that.disciplineloading = false;
                })
        },
        validateEndDate(val){
            const that = this;

            return val >= that.startdate
        },
        closeMenuStart(){
            const that= this;
            that.menustart = false;
            that.checkForChanges();
        },
        closeMenuEnd(){
            const that= this;
            that.menuend = false;
            that.checkForChanges();
        },
        checkForChanges(){
            const that = this;
            if(that.exportsuccess){
                that.exportsuccess = false;
            }
        },
        exportReport(){
            const that = this;

            if(that.$refs.form.validate()){
                that.exportloading = true;
                that.exportsuccess = false;
                let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py';

                that.exportResultData = [];
                that.exportResultHeaders = [];

                let exportCriteria = {
                    "subject" : that.subject,
                    "course" : that.course,
                    "section" : that.section,
                    "ssrcomponent": that.ssrcomponent,
                    "datestart" : that.startdate,
                    "dateend" : that.enddate,
                    "exportmap" : that.exportmap
                }

                const formData = new FormData();
                formData.append("mode", "exportdata");
                formData.append("data", JSON.stringify(exportCriteria));

                fetch(api, {
                    method: 'POST',
                    body: formData
                })
                .then(function(response){
                    return response.json();
                })
                .then(function (data) {
                    if(data.result.match(/ok/i)){
                        that.setSnackbar("Successful: "+data.message.toString(), "green");
                        if(data.hasOwnProperty("headers")){
                            data.headers.forEach(element => {
                                element = {"text": element, "value": element, "sortable": false};
                                that.exportResultHeaders.push(element);
                            });
                        }else {
                            that.exportResultHeaders = [];
                        }
                        
                        that.exportResultData = data.data;
                        that.exportsuccess = true;

                        that.downloadExport();
                    }else {
                        that.setSnackbar("Warning: "+data.message.toString(), "orange");
                    }

                    that.exportloading = false;
                    that.$refs.form.resetValidation();
                })
                .catch(function (err) {
                    that.setSnackbar("Error occurred : "+err.toString(), "red");
                    that.exportloading = false;
                })
            }else {
                that.setSnackbar("Form contains invalid input(s)", "orange");
            }
            
        },
        downloadExport(){
            const that = this;

            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=downloadExport';

            fetch(api)
            .then(function(response){
                return response;
            })
            .then(function(data){
                that.setSnackbar("Successful - Download starting", "green");
                window.open(api);
            })
            .catch(function (err) {
                that.setSnackbar("Error occurred : "+err.toString(), "red");
            });
        },
        setSnackbar(msg, color){ //Sets Snackbar
            const that = this;
            that.snackbar = true;
            that.snackbarcolor = color;
            that.text = msg;
        }
    },
    created(){
        const that = this;
        that.getPermissions();
        that.getSubjectList();
    }
}
</script>